import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "antd";
import { LogoutOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { useAuth } from "../../context/AuthContext";

const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    // Await so the server-side logout (audit + refresh-token invalidation)
    // completes before we redirect — otherwise component unmount aborts the
    // in-flight fetch and the audit row never gets written.
    //
    // `logout()` returns true when it's already handled the post-logout
    // routing itself (partner-panel top-level redirect, or postMessage
    // to the host frame in embed mode). Direct UI users get `false` and
    // we fall back to the existing `/login` redirect.
    const handled = await logout();
    if (!handled) {
      navigate("/login");
    }
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        type="primary exempt-from-readonly"
        className="exempt-from-readonly"
        danger
        onClick={showModal}
        icon={<LogoutOutlined />}
      >
        Logout
      </Button>

      <Modal
        title={null}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes, Logout"
        cancelText="Cancel"
        centered
        okButtonProps={{
          className: "exempt-from-readonly",
          style: { backgroundColor: "#004080", borderColor: "#004080" },
        }}
        cancelButtonProps={{
          className: "exempt-from-readonly",
          style: { color: "#004080", borderColor: "#004080" },
        }}
        style={{ textAlign: "center" }}
      >
        <ExclamationCircleFilled
          style={{ fontSize: "60px", color: "#004080", marginBottom: "10px" }}
        />

        <h2
          style={{ color: "#004080", fontWeight: "bold", marginBottom: "10px" }}
        >
          Are you sure you want to log out?
        </h2>
        <p style={{ color: "#004080" }}>
          You will need to log in again to access your account.
        </p>
      </Modal>
    </>
  );
};

export default LogoutButton;
